import { render, staticRenderFns } from "./WorkIconReserved.vue?vue&type=template&id=0143b82c"
import script from "./WorkIconReserved.vue?vue&type=script&lang=js"
export * from "./WorkIconReserved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports